import { useEffect } from 'react';
import triggerTracking, {
    CustomEvent
} from '@blueprint/tracking/dist/Tracking';

function getTrackData(el: HTMLElement) {
    const trackData: CustomEvent = {
        event: 'GAEvent',
        eventCategory: el.dataset.trackCategory || '',
        eventAction: el.dataset.trackAction || ''
    };

    if (el.dataset.trackLabel) {
        trackData.eventLabel = el.dataset.trackLabel;
    }

    if (el.dataset.trackValue) {
        trackData.eventValue = Number(el.dataset.trackValue) || 0;
    }

    return trackData;
}

function pushTrackingObj(e: Event) {
    if ((e.target as HTMLElement).dataset.trackCategory) {
        triggerTracking(getTrackData(e.target as HTMLElement));
    }
}

const useAnalytics = () => {
    useEffect(() => {
        document.addEventListener('click', pushTrackingObj);
        return () => {
            document.removeEventListener('click', pushTrackingObj);
        };
    }, []);
};

export default useAnalytics;
